import { useEffect, useRef, useState } from "react";
import { StepContainer } from "../components/StepContainer";
import {
  ProceduresFields,
  centsToDisplay,
} from "../components/fields/ProceduresFields";
import { useUpdateBusinessContext } from "../hooks/useUpdateBusinessContext";
import { useBusinessContext } from "@/hooks/useBusinessContext";
import { STEPS, findStepIndexBySlug } from "../config/steps";

export interface ProceduresStepProps {
  onValidityChange: (valid: boolean) => void;
  onAttemptContinue: (continueFn: () => Promise<boolean>) => void;
  onMissingChange?: (labels: string[]) => void;
}

export function ProceduresStep({
  onValidityChange,
  onAttemptContinue,
  onMissingChange,
}: ProceduresStepProps) {
  const step = STEPS[findStepIndexBySlug("procedimentos")];
  const { mutateDebounced } = useUpdateBusinessContext();
  const { query: ubcQuery } = useBusinessContext();

  const [ticketDisplay, setTicketDisplay] = useState("");
  const [mainOffer, setMainOffer] = useState("");
  const mainOfferSeeded = useRef(false);
  const [procCount, setProcCount] = useState(0);

  useEffect(() => {
    const row = ubcQuery.data;
    if (!row) return;
    const val = (row as Record<string, unknown>).ticket_medio_cents as number | null | undefined;
    if (val != null && ticketDisplay === "") {
      setTicketDisplay(centsToDisplay(val));
    }
    if (!mainOfferSeeded.current) {
      mainOfferSeeded.current = true;
      const offer = (row as Record<string, unknown>).main_offer as string | null | undefined;
      if (offer) setMainOffer(offer);
    }
  }, [ubcQuery.data, ticketDisplay]);

  useEffect(() => {
    const ok = procCount > 0;
    onValidityChange(ok);
    if (onMissingChange) onMissingChange(ok ? [] : ["ao menos 1 procedimento"]);
  }, [procCount, onValidityChange, onMissingChange]);

  useEffect(() => {
    onAttemptContinue(async () => procCount > 0);
  }, [onAttemptContinue, procCount]);

  return (
    <StepContainer
      icon={step.icon}
      headline={step.headline}
      sub={step.sub}
      importanceNote="Esses dados ajudam a IA a criar conteúdo contextualizado para os seus serviços reais."
    >
      <ProceduresFields
        ticketDisplay={ticketDisplay}
        onTicketChange={(display, cents) => {
          setTicketDisplay(display);
          mutateDebounced({ ticket_medio_cents: cents } as never);
        }}
        mainOffer={mainOffer}
        onMainOfferChange={(next) => {
          setMainOffer(next);
          mutateDebounced({ main_offer: next || null } as never);
        }}
        onProceduresCountChange={setProcCount}
      />
    </StepContainer>
  );
}
